import React from 'react'
import UserScreeningInfo from 'src/app/UserScreeningInfo/UserScreeningInfo'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { userScreeningInfoRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UserScreeningInfoAppRoute: AppRoute = {
  id: AppLocation.UserScreeningInfo,
  routeProps: userScreeningInfoRouteProps,
  component: <UserScreeningInfo />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UserScreeningInfoAppRoute
